/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export class AnimationStyles {
  constructor(public styles: {[key: string]: string | number}[]) {}
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
